export default "__VITE_ASSET__ca14b172__"